// Mono tag chip with four visual variants. Inline-flex so it tiles nicely with
// other chips in a wrap-flex container.
//
//   default : 1px ink, paper bg
//   solid   : ink bg, paper text   (e.g. selected stage)
//   accent  : accent-soft bg
//   muted   : hairline border, ink-3 text  (synonyms etc.)

const VARIANTS = {
  default: 'border-ink bg-paper text-ink',
  solid:   'border-ink bg-ink text-paper',
  accent:  'border-ink bg-accent-soft text-ink',
  muted:   'border-hairline bg-paper text-ink-3',
};

export function Chip({ variant = 'default', children, className = '', style }) {
  return (
    <span
      className={[
        'inline-flex items-center gap-1.5 px-2 py-0.5 border font-mono text-mono-tag whitespace-nowrap',
        VARIANTS[variant] || VARIANTS.default,
        className,
      ].join(' ')}
      style={style}
    >
      {children}
    </span>
  );
}

export default Chip;
